export class Divisao {
  ativo: boolean;
  id: number;
  divisao: string;
  areaId: number;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/divisoes/shared/divisao.model.ts
 **/